module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/6_c16bf9cdbaf3ee638b5c44358ca9e7e1.png";